import { render, staticRenderFns } from "./chatWindow.vue?vue&type=template&id=63beaab5&"
import script from "./chatWindow.vue?vue&type=script&lang=js&"
export * from "./chatWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports